import { forwardRef } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import MenuItem from "@mui/material/MenuItem";
import Link from "@mui/material/Link";

// Material Dashboard 2 React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// custom styles for the DropdownMenuItem
import menuItem from "examples/Items/DropdownMenuItem/styles";

const DropdownMenuItem = forwardRef(({ icon, title, ...rest }, ref) => (
  <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme)}>
    <SoftBox component={Link} py={0.5} display="flex" alignItems="center" lineHeight={1}>
      <SoftTypography variant="body1" color="secondary" lineHeight={0.75}>
        {icon}
      </SoftTypography>
      <SoftTypography variant="button" fontWeight="regular" sx={{ ml: 1 }}>
        {title}
      </SoftTypography>
    </SoftBox>
  </MenuItem>
));

// Typechecking props for the DropdownMenuItem
DropdownMenuItem.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default DropdownMenuItem;
